import React, { useEffect, useRef, useState } from 'react';
import DataItem from './data-item';
import { SkeletonList } from '../../skeleton-list/skeleton-list';
import configService from '../../../utils/config';
import InfiniteScroll from 'react-infinite-scroll-component';

const DataList = ({ data, renderItem, pagination, loading }) => {
	return loading && !data.length ? (
		<SkeletonList itemsCount={4} />
	) : (
		<InfiniteScroll
			dataLength={data.length}
			next={() => pagination.onChange(pagination.current + 1, configService.defaultPageSize)}
			hasMore={data.length < pagination.total}
			loader={<SkeletonList itemsCount={4} />}
			endMessage={
				data.length ? (
					<div className="alert alert-success" style={{ textAlign: 'center' }}>
						That's all
					</div>
				) : null
			}
		>
			{data.map(record => renderItem(record))}
		</InfiniteScroll>
	);
};

DataList.DataItem = DataItem;
export default DataList;
